import { defineMessages } from 'react-intl';

export const menu = defineMessages({
  more: {
    id: 'menu.more',
    description: 'The message for a dropdown button which says, "more"',
    defaultMessage: 'More'
  }
});
